// Metadata visibility is never a grant to read bytes, open a workspace, or act.
// Existing tool gates and fresh, explicit per-row capabilities are both required.
export function artworkCapabilities(row,{canReadArtwork=false,canReviewEmail=false,canRequestRevision=false}={}) {
  const actions=row?.actions||{},access=row?.readAccess
  const sharedBasis=['confirmed_team_saved_artwork','explicit_company_saved_artwork'].includes(access?.basis)
  const readOnly=access?.readOnly===true||access?.shared===true||sharedBasis
  const knownFullAccess=access?.basis==='canonical_primary'&&access?.readOnly===false&&access?.shared===false
  const knownSharedAccess=sharedBasis&&access?.readOnly===true&&access?.shared===true
  const knownManualAccess=access?.basis==='owner_assigned_manual_concept'&&access?.readOnly===false&&access?.shared===false&&row?.manualConcept===true&&row?.linkState==='manual_concept'&&row?.championshipId===null&&typeof row?.companyId==='string'&&row.companyId.length>0
  const knownAccess=knownFullAccess||knownSharedAccess||knownManualAccess
  return {
    readOnly,knownAccess,manualConcept:knownManualAccess,
    readOriginal:knownAccess&&canReadArtwork===true&&actions.readOriginal===true,
    openRecord:knownFullAccess&&Boolean(row?.championshipId)&&actions.openChampionshipRecord===true,
    openJob:(knownFullAccess||knownManualAccess)&&canReadArtwork===true&&actions.openWorkspaceJob===true,
    prepareEmail:knownFullAccess&&canReviewEmail===true&&Boolean(row?.championshipId)&&actions.openEmailReview===true,
    requestRevision:knownFullAccess&&canRequestRevision===true&&actions.requestRevision===true,
  }
}
